import { render, staticRenderFns } from "./onesti-slogan.vue?vue&type=template&id=7a517cf3&scoped=true&"
import script from "./onesti-slogan.vue?vue&type=script&lang=js&"
export * from "./onesti-slogan.vue?vue&type=script&lang=js&"
import style0 from "./onesti-slogan.vue?vue&type=style&index=0&id=7a517cf3&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a517cf3",
  null
  
)

export default component.exports